/* eslint-env browser */
import Url from 'url';
import _ from 'lodash';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import types from 'frontend/state/actionTypes';

import { API_LOCALES } from 'shared/locale';

function localeReducer(state = null, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case types.SELECT_LOCALE:
      return payload;
    default:
      return state;
  }
}

export default combineReducers({
  locale: localeReducer,
});

const rawLocaleSelector = state => state.locale.locale;
const localeSelector = createSelector(
  rawLocaleSelector,
  locale => {
    const url = Url.parse(window.location.href, true);
    const urlLocale = url.query.locale;
    const search = urlLocale || locale;
    return _.find(API_LOCALES, { locale: search }) || _.find(API_LOCALES, { locale: 'en_US' });
  },
);

export const selectors = {
  rawLocale: rawLocaleSelector,
  locale: localeSelector,
};
